var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 6,
    fill: "#FD5181",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 36C21.25 38.125 22.875 39.75 25 39.75H35C37.125 39.75 38.75 38.125 38.75 36H21.25Z",
    fill: "#FD5181"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 33.5H21.25C20.5 33.5 20 33 20 32.25C20 31.5 20.5 31 21.25 31H38.75C39.5 31 40 31.5 40 32.25C40 33 39.5 33.5 38.75 33.5Z",
    fill: "#FD5181"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.25 21H28.75C24.625 21 21.25 24.375 21.25 28.5H38.75C38.75 24.375 35.375 21 31.25 21ZM27.5 26C26.75 26 26.25 25.5 26.25 24.75C26.25 24 26.75 23.5 27.5 23.5C28.25 23.5 28.75 24 28.75 24.75C28.75 25.5 28.25 26 27.5 26ZM32.5 26C32.5 26.75 33 27.25 33.75 27.25C34.5 27.25 35 26.75 35 26C35 25.25 34.5 24.75 33.75 24.75C33 24.75 32.5 25.25 32.5 26Z",
    fill: "#FD5181"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFatIcon);
export default __webpack_public_path__ + "static/media/fat-icon.82c6cb9fd2b3e6307fca82c2f796ed14.svg";
export { ForwardRef as ReactComponent };